export const componentStyles = new String(".hp-select-input{font-size:.8125rem;&.is-placholder{color:gray}}");
componentStyles.__hash = "9272064ecffd449c";
